const moment = require('moment')


const formatDocument = doc => (
  {
    id: doc.id,
    name: doc.attributes.displayName,
    sharedBy: doc.attributes.sharedBy,
    type: doc.attributes.fileType.toUpperCase(),
    date: moment(doc.attributes.createdAt).format('MMM. D, YYYY')
  }
)

export const formatDocuments = docs => docs.map(doc => formatDocument(doc))

export const findTabConfig  = (property, propertyValue) => {
  const tabConfig = Object.values(documentTabConfig).find(d => d[property] === propertyValue)
  return tabConfig ? tabConfig : {}
}

export const getURLFromTabLabel = (tabLabel) => {
  const tabConfig = findTabConfig('label', tabLabel)
  return tabConfig.path
}

export const getActiveTab = (currentDocumentPath) => {
  const tabConfig = findTabConfig('path', currentDocumentPath)
  return tabConfig.label
}

export const parseParentFolderName = (parentFolderName) => {
  let parsedParentFolderName = parentFolderName
  if (parsedParentFolderName === documentTabConfig.statements.originalName) {
    parsedParentFolderName = documentTabConfig.statements.label
  }
  return parsedParentFolderName.toLowerCase()
}

export const MY_UPLOADS = 'MY_UPLOADS'
export const SHARED_WITH_ME = 'SHARED_WITH_ME'

export const documentTabConfig = {
  myUploads: {
    path: 'my-uploads',
    label: 'my uploads',
    umbrellaFolder: MY_UPLOADS
  },
  proposals: {
    path: 'proposals',
    label: 'proposals',
    title: 'proposals',
    umbrellaFolder: SHARED_WITH_ME
  },
  statements: {
    path: 'statements',
    label: 'statements',
    originalName: 'Statements &amp; Reports',
    title: 'statements and reports',
    umbrellaFolder: SHARED_WITH_ME
  },
  taxForms: {
    path: 'tax-forms',
    label: 'tax forms',
    title: 'tax forms',
    umbrellaFolder: SHARED_WITH_ME
  },
  sharedWithMe: {
    label: 'shared with me',
    umbrellaFolder: SHARED_WITH_ME
  },
  other: {
    path: 'other',
    label: 'other',
    title: 'other',
    umbrellaFolder: SHARED_WITH_ME
  },
  alternatives: {
    path: 'alternatives',
    label: 'alternatives',
    title: 'alternatives',
    umbrellaFolder: SHARED_WITH_ME
  }
}

export const documentTypesByUmbrella = type => Object.values(documentTabConfig)
  .filter(c => c.umbrellaFolder === type)
  .map(c => c.label)




// WEBPACK FOOTER //
// ./src/utils/Client/documents.js